<template>
	<transition :name="`floating-${meterChange}-change-indicator`" @after-enter="$emit('complete')">
		<div class="floating-change-indicator" v-if="animating">
			<slot></slot>
		</div>
	</transition>
</template>

<script>

export default {
	name: 'FloatingChangeIndicator',
	props: {
		animating: {
			required: true,
			type: Boolean,
		},
		meterChange: {
			type: String,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
	.floating-change-indicator {
		height: 100%;
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/components/base/FloatingChangeIndicator.vue